import { render, staticRenderFns } from "./ContractProjectTable.vue?vue&type=template&id=31240ff0&scoped=true&"
import script from "./ContractProjectTable.vue?vue&type=script&lang=js&"
export * from "./ContractProjectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31240ff0",
  null
  
)

export default component.exports